import React, { useCallback, useEffect, useState } from "react";

//Import Breadcrumb
import { Box, Grid, LinearProgress, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Logo from '../../assets/images/Logo.svg';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import Helpers from "../../helpers/helpers";
import { createAdvert, getAdvertInterestRate, getErpDetails, getGeneral, requestMakeModel, requestSingpass, resetAdvertActionState, searchGeneral } from "../../store/actions";
import "./advert.css";
import AddContact from "./Form/AddContact";
import AdvertisementInfo from "./Form/AdvertisementInfo";
import AdvertType from "./Form/AdvertType";
import AssignSalesman from "./Form/AssignSalesman";
import PlanInfo from "./Form/PlanInfo";
import PricingInfo from "./Form/PricingInfo";
import Review from "./Form/Review";
import UploadMedia from "./Form/UploadMedia";
import VehicleInfo from "./Form/VehicleInfo";
import VehicleList from "./Form/VehicleList";
import VerifyVehicle from "./Form/VerifyVehicle";
import MakeModelChoosingModal from "./modal/MakeModelChoosing";
import RequestMakeModelModal from "./modal/RequestMakeModel";
import SingpassLoginModal from "./modal/SingpassLogin";
// import PlateNoDetectionHelper from "../../helpers/plate_no_detection_helper";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import moment from "moment";
import AppDialog from "../../components/Common/AppDialog";
import VehicleDetailsSummaryModal from "./modal/VehicleDetailsSummary";

const normalizeEngineCap = (value) => {
    if (typeof value !== 'string') {
        return value;
    }

    return value.replace(/\s*cc\s*$/i, '').trim();
};


const AddAdvert = ({ leftSideBarType, layoutWidth, addAdvert, planList, userData, isDirectSeller, makeList, modelList, bodyList, advertRequestMakeModel, erpDetails, singpassRes, transmissionList, generalCommonCode, erpListingInd }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const planId = new URLSearchParams(window.location.search).get("plan_id");
    const totalPage = 9;
    const [currentStep, setCurrentStep] = useState(1);
    const [formObj, setFormObj] = useState({ vehicle: { mileage: "", no_of_owner: "", engine_cap: "" }, pricing: { max_loan_tenure: 0, loan_amount: 0, monthly_instalment: "", term_charge: 0, }, contact_agreement: false });
    const [requestObj, setRequestObj] = useState({ remark: "", request_type: "motorcycle_make" });
    const [agreement, setAgreement] = useState(false);
    const [chooseManualOpen, setChooseManualOpen] = useState(false);
    const [requestNewOpen, setRequestNewOpen] = useState(false);
    const [vehicleDetailsOpen, setVehicleDetailsOpen] = useState(false);
    const [singpassLoginOpen, setSingpassLoginOpen] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const [draft, setDraft] = useState(false);
    const [photoState, setPhotoState] = useState(0);
    const [preSelectBodyType, setPreSelectBodyType] = useState([]);
    const [showSubmitLoadingMessage, setShowSubmitLoadingMessage] = useState(false);
    const [singPassFillUpManually, setSingPassFillUpManually] = useState(false);
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const [defaultMyinfo, setDefaultMyinfo] = useState({ make: "", model: "" });
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const isSingPass = isDirectSeller && formObj?.is_manually_fill !== true ? true : false;

    const removeTokenFromUrl = useCallback(() => {
        const searchParams = new URLSearchParams(window.location.search);
        if (!searchParams.has('token')) return;

        searchParams.delete('token');
        const nextSearch = searchParams.toString();
        navigate(`${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`, { replace: true });
    }, [navigate]);

    const steps = [
        { header: 'First, choose your advert plan.', buttonText: 'Choose Advert Plan' },
        { header: isDirectSeller ? 'Verify vehicle info & ownership' : 'Next, choose your advert type.', buttonText: isDirectSeller ? 'Verify Vehicle Info & Ownership' : 'Select Advert Type' },
        { header: isDirectSeller ? 'Select vehicle for sale' : 'Next, select vehicle', buttonText: 'Select Vehicle' },
        { header: 'Tell us more about the motorcycle.', buttonText: 'Vehicle Info' },
        { header: 'Set your pricing', buttonText: 'Pricing Details' },
        { header: 'Define advertisement details', buttonText: 'Advert Details' },
        { header: isDirectSeller ? 'Contact info' : 'Assign salesman', buttonText: isDirectSeller ? 'Contact Info' : 'Assign Salesman' },
        { header: 'Upload media', buttonText: 'Upload Media' },
        { header: 'Review and confirm', buttonText: 'Preview & Publish' }
    ]

    useEffect(() => {
        dispatch(getGeneral());
        dispatch(getAdvertInterestRate());
        dispatch(searchGeneral({ type: "bike_makes", search: "" }));
    }, [])

    useEffect(() => {
        if (!isDirectSeller && formObj?.selected_vehicle_id) {
            setIsLoading(true);
            dispatch(getErpDetails({ id: formObj?.selected_vehicle_id }));
        } else if (isDirectSeller && formObj?.selected_vehicle_id && formObj?.is_manually_fill === true) {
            setIsLoading(true);
            dispatch(getErpDetails({ id: formObj?.selected_vehicle_id }));
        }
    }, [formObj?.selected_vehicle_id])

    useEffect(() => {
        if (singpassRes?.code === 'success') {
            setIsLoading(false);
            window.location.href = singpassRes?.data;
            dispatch(resetAdvertActionState());
        } else if (singpassRes?.code === 'network_error' || singpassRes?.code === 'invalid_field' || singpassRes?.code === 'error' || singpassRes?.code === 'unknown' || singpassRes?.code === 'unauthorized' || singpassRes?.code === 'forbidden' || singpassRes?.code === 'not_found' || singpassRes?.code === "unknown_error") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: singpassRes?.message || singpassRes?.error_message || singpassRes?.data?.error_message || 'Failed to redirect to Singpass. Please try again.',
                type: 'error',
            });
            // dispatch(resetAdvertActionState());
        } else if (singpassRes?.code && singpassRes?.code !== "success") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: singpassRes?.message || singpassRes?.error_message || singpassRes?.data?.error_message || "Failed",
                type: 'error',
            });
        }
    }, [singpassRes]);

    useEffect(() => {
        if (planId) {
            handleFormObjChange('bike_advert_plan_id', Number(planId));
            setCurrentStep(3);
        }
    }, [planId])

    useEffect(() => {
        if (isSingPass && currentStep === 4) {
            removeTokenFromUrl();
        }
    }, [currentStep, isSingPass, removeTokenFromUrl])

    useEffect(() => {//set state when erp is selected from the list
        if (erpDetails?.data) {
            if (formObj?.open_selected_vehicle === true) {
                setVehicleDetailsOpen(true);
                handleFormObjChange('open_selected_vehicle', false);
            } else if ((erpDetails?.data?.id) === formObj?.selected_vehicle_id) {
                const regDateRaw = erpDetails.data?.reg_date || erpDetails.data?.first_reg_date;
                const coeDateRaw = erpDetails.data?.coe_expiry;
                // const regDate = regDateRaw ? moment(regDateRaw, "YYYY-MM-DD").format('YYYY-MM-DD') : null;
                // const coeDate = coeDateRaw ? moment(coeDateRaw, "DD MMM YYYY").format('YYYY-MM-DD') : null;
                setFormObj(prev => ({
                    ...prev,
                    vehicle: {
                        ...prev?.vehicle,
                        ...erpDetails.data,
                        transmission: erpDetails.data?.transmission,
                        engine_cap: normalizeEngineCap(erpDetails.data?.engine_cap),
                        reg_date: regDateRaw,
                        coe_expiry: coeDateRaw,
                        mileage: erpDetails?.erp_data?.mileage ?? 0,
                        no_of_owner: erpDetails?.erp_data?.no_of_owner ?? 0,
                    }
                }));
            } else if (isDirectSeller && formObj?.is_manually_fill !== true && !erpDetails?.data?.id) {//for singpass
                const selectedData = erpListingInd?.data?.data?.find((item, idx) => idx === formObj?.selected_vehicle_id);
                // dispatch(setErpDetailsLocal({ data: selectedData }));
                const regDateRaw = selectedData?.reg_date || selectedData?.first_reg_date;
                const coeDateRaw = selectedData?.coe_expiry || selectedData?.first_coe_expiry;
                setDefaultMyinfo({
                    make: selectedData?.make,
                    model: selectedData?.model
                });
                setFormObj(prev => ({
                    ...prev,
                    vehicle: {
                        ...prev?.vehicle,
                        ...selectedData,
                        transmission: selectedData?.transmission,
                        engine_cap: normalizeEngineCap(selectedData?.engine_cap),
                        reg_date: regDateRaw || null,
                        coe_expiry: coeDateRaw || null,
                        mileage: selectedData?.mileage ?? 0,
                        no_of_owner: selectedData?.no_of_owner ?? 0,
                    }
                }));
            }
            setIsLoading(false);
        }
    }, [erpDetails])


    useEffect(() => {
        //for singpass show error message (data expired etc.)
        if (erpListingInd?.code === "error" && erpListingInd?.message !== "No vehicle details found in MyInfo. Please enter your vehicle details manually.") {
            // setIsLoading(false);
            setNotification({ open: true, type: 'error', msg: erpListingInd?.message || "Something went wrong, please try again later" });
            setSingPassFillUpManually(false)
        } else if (erpListingInd?.code === "error" && erpListingInd?.message === "No vehicle details found in MyInfo. Please enter your vehicle details manually.") {
            setSingPassFillUpManually(true)
            setNotification({ open: true, type: 'error', msg: erpListingInd?.message || "Something went wrong, please try again later" });

        }
    }, [erpListingInd]);

    useEffect(() => {//preset pricing type based on advert type on initial load
        handleFormObjChange('pricing', { ...formObj?.pricing, price_type: isDirectSeller ? 4 : formObj?.advert_type === "new" ? 1 : formObj?.advert_type === "used" ? 4 : formObj?.pricing?.price_type });
    }, [isDirectSeller, formObj?.advert_type])

    useEffect(() => {//preset pricing type based on advert type on initial load
        setFormObj(prev => ({
            ...prev,
            advert_type: isDirectSeller ? "used" : prev?.advert_type === "new" ? "new" : prev?.advert_type === "used" ? "used" : prev?.advert_type === "rental" ? "rental" : prev?.advert_type
        }))
    }, [isDirectSeller])

    useEffect(() => {
        if (!addAdvert?.code && addAdvert?.status === undefined) return;

        setIsLoading(false);
        setShowSubmitLoadingMessage(false);

        if (addAdvert?.code === 'success' || addAdvert?.code === 'validate_success') {
            if (currentStep === 3 && !isSingPass && addAdvert?.erp_data) {
                const data = addAdvert?.erp_data || formObj?.vehicle;
                setPreSelectBodyType([data?.body_type_id] || []);
                handleFormObjChange('vehicle', { ...formObj?.vehicle, transmission: data?.transmission, engine_cap: normalizeEngineCap(data?.engine_cap), reg_date: data?.reg_date, coe_expiry: data?.coe_expiry, mileage: data?.mileage, no_of_owner: data?.no_of_owner, body_type: data?.body_type_id ? [data?.body_type_id] : [], });
                handleFormObjChange('pricing', { ...formObj?.pricing, purchase_price: (data?.purchase_price)?.toFixed(2), suggested_price: (data?.suggested_price)?.toFixed(2), arf: (data?.arf)?.toFixed(2) });
                dispatch(getGeneral());
            }
            if (currentStep === 4) {
                const defaultTenure = addAdvert?.default_loan_tenure;
                const availablePt = isDirectSeller ? [4, 3] : (formObj?.advert_type === 'used' ? [4, 2, 3] : [1, 2, 3]);
                const existingPtData = formObj?.pricing?.price_type_data || {};
                const updatedPtData = availablePt.reduce((acc, pt) => {
                    acc[pt] = { ...existingPtData[pt], max_loan_tenure: defaultTenure };
                    return acc;
                }, {});
                handleFormObjChange('pricing', {
                    ...formObj?.pricing,
                    max_loan_tenure: defaultTenure,
                    max_loan_tenure_calculated: addAdvert?.max_loan_tenure,
                    price_type_data: updatedPtData,
                });
            }
            if (currentStep === totalPage && addAdvert?.code === 'success') {
                setNotification({
                    open: true,
                    msg: addAdvert?.message || 'Your advert has been successfully added.',
                    type: 'success',
                });
                navigate("/advert")
            }
            error && setError({});
            handleNextPage();
            dispatch(resetAdvertActionState());
            dispatch(getGeneral());
        } else {
            setNotification({
                open: true,
                msg: addAdvert?.message || 'Something went wrong. Please try again.',
                type: 'error',
            });
            setError(addAdvert?.errors || {});
        }
    }, [addAdvert])

    useEffect(() => {
        if (advertRequestMakeModel?.code === 'success') {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: advertRequestMakeModel?.message || 'Your request has been submitted successfully.',
                type: 'success',
            });
            error && setError({});
            setRequestObj({});
            setRequestNewOpen(false);
            dispatch(resetAdvertActionState());
        } else if (advertRequestMakeModel?.code === 'invalid_field') {
            setIsLoading(false);
            setError(advertRequestMakeModel?.errors);
            setNotification({
                open: true,
                msg: advertRequestMakeModel?.message || 'Some fields are invalid. Please check again.',
                type: 'error',
            });
            dispatch(resetAdvertActionState());
        }
    }, [advertRequestMakeModel])

    const handleFormObjChange = (key, value) => {
        setFormObj((prev) => ({
            ...prev,
            [key]: value,
        }));
    }

    const handleVehicleObjChange = (key, value) => {
        setFormObj(prev => {
            let tempObj = { ...prev.vehicle };
            tempObj[key] = value;
            if (key === 'bike_make_id') {
                tempObj['bike_model_id'] = null;
                tempObj['make'] = makeList?.find((make) => make.id === value)?.name || '';
            }
            if (key === 'bike_model_id') {
                tempObj['bike_model_colour_id'] = "";
                // tempObj['body_type'] = null;
                tempObj['model'] = modelList?.find((model) => model.id === value)?.name || '';
            }
            if (key === 'bike_model_colour_id') {
                tempObj['bike_model_colour_id'] = value;
            }
            return { ...prev, vehicle: tempObj };
        });
    }

    const handlePricingObjChange = (key, value) => {
        setFormObj(prev => ({ ...prev, pricing: { ...prev.pricing, [key]: value } }));
    }

    const handlePricingTypeDataChange = (priceType, key, value) => {
        setFormObj(prev => ({
            ...prev,
            pricing: {
                ...prev.pricing,
                price_type_data: {
                    ...prev.pricing?.price_type_data,
                    [priceType]: {
                        ...prev.pricing?.price_type_data?.[priceType],
                        [key]: value,
                    },
                },
            },
        }));
    }

    const handleAdvertisementObjChange = (key, value) => {
        setFormObj((prev) => ({
            ...prev,
            advertisement: {
                ...prev.advertisement,
                [key]: value,
            },
        }));
    }

    const handleAddManually = (item) => {

        if (formObj?.vehicle?.bike_make_id && formObj?.vehicle?.bike_model_id) {
            // call api
            //after success go next step
            handleNextPage();
            setChooseManualOpen(false);
            handleFormObjChange('vehicle', { ...formObj?.vehicle, transmission: item?.transmission, engine_cap: normalizeEngineCap(item.engine_cc), reg_date: item.reg_date, coe_expiry: item.coe_expiry, mileage: item.mileage, no_of_owner: item.no_of_owner, manu_year: item.manu_year, license_category_id: item.license_category, bike_model_colour_id: item.bike_model_colour_id, body_type: item.body_type });
        }
        else {
            setNotification({
                open: true,
                msg: 'Make and model field is required.',
                type: 'error',
            });
        }

    }

    const handleSubmitRequest = () => {
        setIsLoading(true);
        let payload = {
            remarks: requestObj?.remarks
        }
        if (requestObj?.request_type === 'motorcycle_make') {
            payload.bike_make_name = requestObj?.bike_make_name;
        } else {
            payload.bike_make_id = requestObj?.bike_make_id;
            payload.bike_model_name = requestObj?.bike_model_name;
            payload.bike_model_year = requestObj?.bike_model_year;
        }
        dispatch(requestMakeModel(payload));
    }

    const handleGoBack = () => {
        if (isDirectSeller && currentStep === 4) {
            setCurrentStep(2);
        } else if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        } else {
            navigate('/advert');
        }
    }
    const handleNextPage = () => {
        if (isSingPass && currentStep === 3 && (formObj?.selected_vehicle_id === null || formObj?.selected_vehicle_id === undefined)) {
            setNotification({
                open: true,
                msg: 'Please select a vehicle before proceed to next step.',
                type: 'error',
            });
            return;
        }
        if (currentStep <= totalPage) {
            setCurrentStep(currentStep + 1);
        }
    }

    const handleRedirectSingpass = () => {
        setIsLoading(true);
        dispatch(requestSingpass({ bike_advert_plan_id: formObj?.bike_advert_plan_id }));
    }

    const handleVerifyForm = async (isDraft, proceedWithoutCheckImage = false) => {
        let is_image_not_masked = false;

        setIsLoading(true);
        // setPhotoState(0);
        // setShowSubmitLoadingMessage(false);
        let payload = { step: currentStep === totalPage ? (isDraft ? 'draft' : 'publish') : currentStep };
        if (currentStep === 1 || currentStep === 9) {
            payload.bike_advert_plan_id = formObj?.bike_advert_plan_id;
        }
        if (currentStep === 2 || currentStep === 9) {
            payload.bike_advert_type = formObj?.advert_type;
        }
        if (currentStep === 3 || currentStep === 9) {
            payload.erp_id = formObj?.vehicle?.id;
            // payload.require_singpass = 1;
            // payload.singpass_id = 6
            // payload.step = 3
        }
        if (currentStep === 4 || currentStep === 9) {
            payload.bike_advert_type = formObj?.advert_type;
            payload.bike_make_id = formObj?.vehicle?.bike_make_id;
            payload.bike_model_id = formObj?.vehicle?.bike_model_id;
            payload.manu_year = formObj?.vehicle?.manu_year || null;
            payload.license_category_id = formObj?.vehicle?.license_category_id;
            payload.bike_model_colour_id = formObj?.vehicle?.bike_model_colour_id;
            if (formObj?.advert_type !== 'used' && !formObj?.vehicle?.bike_model_colour_id) {
                payload.colour_text = formObj?.vehicle?.colour_text;
            }
            payload.body_types = formObj?.vehicle?.body_type || [];
            payload.transmission = formObj?.vehicle?.transmission;
            payload.engine_cc = formObj?.vehicle?.engine_cap ? Number(formObj?.vehicle?.engine_cap) : null;
            payload.bike_advert_plan_id = formObj?.bike_advert_plan_id;
            if (formObj?.advert_type === 'new') {
                payload.vehicle_source = formObj?.vehicle?.vehicle_source;
            }

            if (formObj?.advert_type === 'used') {
                payload.registration_date = formObj?.vehicle?.reg_date;
                payload.coe_expiry = formObj?.vehicle?.coe_expiry;
                payload.mileage_in_km = formObj?.vehicle?.mileage;
                payload.no_of_previous_owners = formObj?.vehicle?.no_of_owner;
            }
        }
        if (currentStep === 5 || currentStep === 9) {
            payload.bike_advert_type = formObj?.advert_type;
            payload.license_category_id = formObj?.vehicle?.license_category_id;

            if (formObj?.advert_type === 'rental') {
                payload.daily_rate = formObj?.pricing?.daily_rate;
                payload.weekend_rate = formObj?.pricing?.weekend_rate;
                payload.weekly_rate = formObj?.pricing?.weekly_rate;
                payload.monthly_rate = formObj?.pricing?.monthly_rate;
                payload['3_days_rate'] = formObj?.pricing?.three_day_rate;
            } else {
                const availablePriceTypes = isDirectSeller
                    ? [4, 3]
                    : formObj?.advert_type === 'used' ? [4, 2, 3] : [1, 2, 3];

                payload.pricing_type = formObj?.pricing?.price_type;
                payload.pricings = availablePriceTypes.map(priceType => {
                    const ptData = formObj?.pricing?.price_type_data?.[priceType] || {};
                    const entry = {
                        min_downpayment: ptData.min_downpayment === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.min_downpayment) ? null : Number(ptData.min_downpayment),
                        loan_amount: ptData.loan_amount === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.loan_amount) ? null : Number(ptData.loan_amount),
                        max_loan_tenure: ptData.max_loan_tenure === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.max_loan_tenure) ? null : Number(ptData.max_loan_tenure),
                        interest_rate_id: ptData.interest_rate_id === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(ptData.interest_rate_id) ? null : Number(ptData.interest_rate_id),
                        term_charge: ptData.term_charge === "NaN" ? 0.00 : Helpers.isNullOrEmptyAllowZero(ptData.term_charge) ? 0.00 : Number(ptData.term_charge),
                        monthly_instalment: ptData.monthly_instalment === "NaN" ? 0.00 : Helpers.isNullOrEmptyAllowZero(ptData.monthly_instalment) ? 0.00 : Number(ptData.monthly_instalment),
                        pricing_type: priceType,
                    };
                    if (priceType === 1) {
                        entry.machine_price = formObj?.pricing?.machine_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(formObj?.pricing?.machine_price) ? null : Number(formObj?.pricing?.machine_price);
                        entry.coe = formObj?.pricing?.coe;
                        entry.additional_cost = formObj?.pricing?.additional_costs === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(formObj?.pricing?.additional_costs) ? null : Number(formObj?.pricing?.additional_costs);
                    }
                    if (priceType === 3) {
                        entry.promotion_price = formObj?.pricing?.promotion_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(formObj?.pricing?.promotion_price) ? null : Number(formObj?.pricing?.promotion_price);
                    }
                    if (priceType === 4) {
                        entry.selling_price = formObj?.pricing?.selling_price === "NaN" ? null : Helpers.isNullOrEmptyAllowZero(formObj?.pricing?.selling_price) ? null : Number(formObj?.pricing?.selling_price);
                    }
                    return entry;
                });
            }
        }
        if (currentStep === 6 || currentStep === 9) {
            payload.bike_advert_type = formObj?.advert_type;
            payload.title = formObj?.advertisement?.title;
            payload.title_remark = formObj?.advertisement?.title_remark;
            payload.description = formObj?.advertisement?.dealer_description;
            payload.test_ride_url = formObj?.advertisement?.test_ride_url;
            payload.test_ride_salesman_id = formObj?.advertisement?.test_ride_salesman_id;
            payload.taggings = formObj?.advertisement?.taggings;
            payload.featured_tagging_id = formObj?.advertisement?.featured_tagging_id || null;
        }
        if (currentStep === 7 || currentStep === 9) {
            payload.salesmans = formObj?.salesman?.map((item) => ({
                salesman_id: item?.salesman_id,
                location_id: item?.location_id,
            }));
        }
        if (currentStep === 8 || currentStep === 9) {
            let images = [];
            if (formObj?.photos && formObj?.photos.length > 0) {
                // setShowSubmitLoadingMessage(true);
                const totalPhotos = formObj.photos.length;
                let completedPhotos = 0;

                const imageResults = await Promise.all(
                    formObj.photos.map(async (_, index) => {
                        const img = formObj.photos[index];
                        // const imageNotMasked = currentStep === 8 ? (proceedWithoutCheckImage ? false : (is_image_not_masked ? true : await PlateNoDetectionHelper(img.file_base64))) : false;
                        const imageNotMasked = false;

                        // completedPhotos += 1;
                        // setPhotoState(Math.min(99, Math.round((completedPhotos / totalPhotos) * 100)));

                        return {
                            imageNotMasked,
                            image: {
                                is_thumbnail: img?.is_thumbnail ? 1 : 0,
                                name: img.file_name,
                                file: img.file_base64,
                            },
                        };
                    })
                );

                is_image_not_masked = imageResults.some(result => result.imageNotMasked);
                images.push(...imageResults.map(result => result.image));
            }
            payload.images = images;
            payload.youtube_url = formObj?.youtube_url;
            payload.facebook_url = formObj?.facebook_url;
            payload.instagram_url = formObj?.instagram_url;
            payload.tiktok_url = formObj?.tiktok_url;
        }
        if (currentStep === 9) {
            payload.disclaimed = agreement ? 1 : 0;
        }
        if (!proceedWithoutCheckImage && is_image_not_masked) {
            setIsLoading(false);
            // setShowSubmitLoadingMessage(false);
            setErrorModalOpen(true)
            return;
        }
        setPhotoState(100);
        dispatch(createAdvert(payload));
    }
    const handleDirectSellerVerifyForm = async (isDraft, proceedWithoutCheckImage = false) => {
        let is_image_not_masked = false;
        // if (isSingPass) {
        //     dispatch(setErpDetailsLocal({ data: selectedVehicleSingPass }));
        //     setFormObj(prev => ({
        //         ...prev,
        //         vehicle: {
        //             ...prev?.vehicle,
        //             ...selectedVehicleSingPass,
        //             transmission: selectedVehicleSingPass?.transmission,
        //             engine_cap: normalizeEngineCap(selectedVehicleSingPass?.engine_cap),
        //             reg_date: selectedVehicleSingPass?.reg_date,
        //             coe_expiry: selectedVehicleSingPass?.coe_expiry,
        //             mileage: selectedVehicleSingPass?.mileage ?? 0,
        //             no_of_owner: selectedVehicleSingPass?.no_of_owner ?? 0,
        //         }
        //     }));
        // }
        setIsLoading(true);
        setPhotoState(0);
        setShowSubmitLoadingMessage(false);
        let payload = { step: currentStep === totalPage ? (isDraft ? 'draft' : 'publish') : currentStep };
        if (currentStep === 1 || currentStep === 9) {
            payload.bike_advert_plan_id = formObj?.bike_advert_plan_id;
        }
        if (currentStep >= 2) {
            payload.require_singpass = formObj?.is_manually_fill ? 0 : 1;
        }
        if ((currentStep === 3 || currentStep === 9) && formObj?.is_manually_fill !== 1) {
            payload.singpass_id = formObj?.vehicle?.id;
        } else if ((currentStep === 3 || currentStep === 9) && formObj?.is_manually_fill == 1) {
            payload.erp_id = formObj?.vehicle?.id;

        }
        // if (currentStep === 3 && formObj?.is_manually_fill !== 1) {
        //     payload.singpass_id = formObj?.vehicle?.id;
        // }
        if (currentStep === 4 || currentStep === 9) {
            if (isSingPass) {
                payload.myinfo_make = formObj?.vehicle?.make;
                payload.myinfo_model = formObj?.vehicle?.model;
                payload.register_number = formObj?.vehicle?.reg_no;
            }
            payload.bike_advert_type = "used";
            payload.bike_make_id = formObj?.vehicle?.bike_make_id;
            payload.bike_model_id = formObj?.vehicle?.bike_model_id;
            payload.manu_year = formObj?.vehicle?.manu_year || null;
            payload.license_category_id = formObj?.vehicle?.license_category_id;
            payload.bike_model_colour_id = formObj?.vehicle?.bike_model_colour_id;
            payload.body_types = formObj?.vehicle?.body_type || [];
            payload.transmission = formObj?.vehicle?.transmission;
            payload.engine_cc = formObj?.vehicle?.engine_cap ? Number(formObj?.vehicle?.engine_cap) : null;
            payload.no_of_previous_owners = formObj?.vehicle?.no_of_owner;
            payload.registration_date = formObj?.vehicle?.reg_date;
            payload.coe_expiry = formObj?.vehicle?.coe_expiry;
            payload.mileage_in_km = formObj?.vehicle?.mileage;

            if (formObj?.advert_type === 'new') {
                payload.vehicle_source = formObj?.vehicle?.vehicle_source;
            }
        }
        if (currentStep === 5 || currentStep === 9) {
            const availablePriceTypes = [4, 3];
            payload.pricing_type = formObj?.pricing?.price_type;
            payload.pricings = availablePriceTypes.map(priceType => {
                const ptData = formObj?.pricing?.price_type_data?.[priceType] || {};
                const entry = { pricing_type: priceType };
                if (priceType === 4) {
                    entry.selling_price = ptData.selling_price === "NaN" || ptData.selling_price == 0.00 ? null : ptData.selling_price;
                }
                if (priceType === 3) {
                    entry.promotion_price = ptData.promotion_price === "NaN" || ptData.promotion_price == 0.00 ? null : ptData.promotion_price;
                    entry.selling_price = ptData.selling_price === "NaN" || ptData.selling_price == 0.00 ? null : ptData.selling_price;
                }
                return entry;
            });
        }
        if (currentStep === 6 || currentStep === 9) {
            payload.title = formObj?.advertisement?.title;
            payload.title_remark = formObj?.advertisement?.title_remark;
            payload.description = formObj?.advertisement?.dealer_description;
            payload.taggings = formObj?.advertisement?.taggings;
            payload.featured_tagging_id = formObj?.advertisement?.featured_tagging_id || null;
        }
        if (currentStep === 7 || currentStep === 9) {
            payload.salesmans = formObj?.contacts?.map((item) => ({
                name: item?.name,
                phone: item.phone,
                // email: item?.email,
                // is_default:1,
                disclaimed: formObj?.contact_agreement ? 1 : 0,
            }));
        }
        if (currentStep === 8 || currentStep === 9) {
            let images = [];
            if (formObj?.photos && formObj?.photos.length > 0) {
                setShowSubmitLoadingMessage(true);
                const totalPhotos = formObj.photos.length;
                let completedPhotos = 0;

                const imageResults = await Promise.all(
                    formObj.photos.map(async (_, index) => {
                        const img = formObj.photos[index];
                        // const imageNotMasked = currentStep === 8 ? (proceedWithoutCheckImage ? false : (is_image_not_masked ? true : await PlateNoDetectionHelper(img.file_base64))) : false;
                        const imageNotMasked = false;

                        // completedPhotos += 1;
                        // setPhotoState(Math.min(99, Math.round((completedPhotos / totalPhotos) * 100)));

                        return {
                            imageNotMasked,
                            image: {
                                is_thumbnail: img?.is_thumbnail ? 1 : 0,
                                name: img.file_name,
                                file: img.file_base64,
                            },
                        };
                    })
                );

                is_image_not_masked = imageResults.some(result => result.imageNotMasked);
                images.push(...imageResults.map(result => result.image));
            }
            payload.images = images;
            payload.youtube_url = formObj?.youtube_url;
            payload.facebook_url = formObj?.facebook_url;
            payload.instagram_url = formObj?.instagram_url;
            payload.tiktok_url = formObj?.tiktok_url;
        }
        if (currentStep === 9) {
            payload.disclaimed = agreement ? 1 : 0;
        }
        if (!proceedWithoutCheckImage && is_image_not_masked) {
            setIsLoading(false);
            setShowSubmitLoadingMessage(false);
            setErrorModalOpen(true)
            return;
        }
        setPhotoState(100);
        dispatch(createAdvert(payload));
    }

    const handleLoginSingpass = () => {
        // call singpass login api
        //if success get the vehicle list
        // and go to next step
        setCurrentStep(currentStep + 1);
        setSingpassLoginOpen(false);
    }

    return (
        <React.Fragment>
            {
                layoutWidth > 768 &&
                <div style={{ position: 'fixed', zIndex: 9, width: '100%', backgroundColor: 'white', paddingBottom: 10 }}>
                    <div className="d-flex mb-2" style={{ backgroundColor: '#A70000', height: 10, width: `${(currentStep / totalPage * 100)}%`, transition: 'width 0.5s ease' }}></div>
                    <img src={Logo} alt="Logo" style={{ height: 21, width: 91, objectFit: 'contain' }} />
                </div>
            }
            <div className="page-content" style={{ marginTop: layoutWidth <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || (generalCommonCode?.code !== "success")}
                // message={showSubmitLoadingMessage && currentStep === 8 ? (photoState >= 100 ? "Processing completed, submitting data...please wait" : <div style={{ textAlign: "center" }}>{photoState}% <br />Processing photo please wait...</div>) : undefined}

                />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    {
                        // currentStep <= totalPage ?
                        <Box pt={layoutWidth <= 768 ? 2 : 6} pb={6} px={layoutWidth <= 768 ? 2 : 8}>
                            {
                                layoutWidth <= 768 &&
                                <div style={{ width: '100%', color: '#D13536', backgroundColor: '#F5F5F5', marginBottom: 20 }}>
                                    <LinearProgress value={currentStep / totalPage * 100} variant="determinate" color="inherit" style={{ height: 9, borderRadius: 100 }} />
                                </div>
                            }
                            <Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12} >
                                    <div className="subheader-2">Step {currentStep} of {totalPage}</div>
                                    <Box className="d-flex justify-content-between" sx={{ flexDirection: { xs: "column", sm: "row" } }} >
                                        <div className="header-2">{steps[currentStep - 1]?.header}</div>
                                        {
                                            currentStep === 3 && !isDirectSeller &&
                                            <div className="d-flex align-items-center subheader-3">
                                                Couldn’t find?
                                                <CustomButton
                                                    title={'ADD MANUALLY'}
                                                    press={() => {
                                                        setChooseManualOpen(true);
                                                        setFormObj(prev => ({ ...prev, "vehicle": {} }));
                                                        setFormObj(prev => ({ ...prev, "is_manually_fill": true }));
                                                        handleFormObjChange('selected_vehicle_id', "");
                                                        handleVehicleObjChange('colour_text', null)

                                                    }}
                                                    backgroundColor={'transparent'}
                                                    textColor={'#B48A3C'}
                                                    borderStyle={'none'}
                                                    padding={5}
                                                    borderRadius={"5px"}
                                                />
                                            </div>
                                        }
                                        {
                                            currentStep === 3 && ((isDirectSeller && singPassFillUpManually)) &&
                                            <div className="d-flex align-items-center subheader-3">
                                                <CustomButton
                                                    title={'FILL UP MANUALLY'}
                                                    press={() => {
                                                        removeTokenFromUrl();
                                                        handleFormObjChange('is_manually_fill', true);
                                                        setCurrentStep(4);
                                                    }}
                                                    padding={20}
                                                    backgroundColor={'transparent'}
                                                    textColor={'#B48A3C'}
                                                    fontSize={{ xs: 12, sm: 14 }}
                                                    borderStyle={'1px solid transparent'}
                                                />
                                            </div>
                                        }
                                    </Box>
                                </Grid>
                                <Grid item md={12} sm={12} xs={12}>
                                    {
                                        currentStep === 1 &&
                                        <PlanInfo
                                            formObj={formObj}
                                            handleFormChange={handleFormObjChange}
                                            isDirectSeller={isDirectSeller}
                                            planList={planList}
                                            userData={userData}
                                            handleVehicleObjChange={handleVehicleObjChange}
                                            error={error?.bike_advert_plan_id}
                                        />
                                    }
                                    {currentStep === 2 && !isDirectSeller && <AdvertType handleVehicleObjChange={handleVehicleObjChange} isSingPass={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} error={error} />}
                                    {currentStep === 2 && isDirectSeller && <VerifyVehicle isSingPass={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} error={error} />}
                                    {currentStep === 3 && <VehicleList isSingPass={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} handleVehicleObjChange={handleVehicleObjChange} windowWidth={layoutWidth} isDirectSeller={isDirectSeller} error={error} setIsLoading={setIsLoading} transmissionList={transmissionList} />}
                                    {currentStep === 4 && <VehicleInfo setVehicleDetailsOpen={setVehicleDetailsOpen} isSingPass={isSingPass} defaultMyinfo={defaultMyinfo} formObj={formObj?.vehicle} handleFormChange={handleVehicleObjChange} advertType={formObj?.advert_type} setRequestNewOpen={setRequestNewOpen} isDirectSeller={isDirectSeller} error={error} transmissionList={transmissionList} preSelectBodyType={preSelectBodyType} setPreSelectBodyType={setPreSelectBodyType} is_manually_fill={formObj?.is_manually_fill} />}
                                    {currentStep === 5 && <PricingInfo setVehicleDetailsOpen={setVehicleDetailsOpen} isSingPass={isSingPass} formObj={formObj?.pricing} handleFormChange={handlePricingObjChange} handlePricingTypeDataChange={handlePricingTypeDataChange} advertType={formObj?.advert_type} vehicle={formObj?.vehicle} windowWidth={layoutWidth} isDirectSeller={isDirectSeller} error={error} setNotification={setNotification} />}
                                    {currentStep === 6 && <AdvertisementInfo setVehicleDetailsOpen={setVehicleDetailsOpen} isSingPass={isSingPass} formObj={formObj?.advertisement} handleFormChange={handleAdvertisementObjChange} vehicle={formObj?.vehicle} isDirectSeller={isDirectSeller} error={error} />}
                                    {currentStep === 7 && !isDirectSeller && <AssignSalesman setVehicleDetailsOpen={setVehicleDetailsOpen} isSingPass={isSingPass} isDirectSeller={isDirectSeller} formObj={formObj} handleFormChange={handleFormObjChange} vehicle={formObj?.vehicle} error={error} />}
                                    {currentStep === 7 && isDirectSeller && <AddContact setVehicleDetailsOpen={setVehicleDetailsOpen} isSingPass={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} vehicle={formObj?.vehicle} error={error} />}
                                    {currentStep === 8 && <UploadMedia setVehicleDetailsOpen={setVehicleDetailsOpen} isSingPass={isSingPass} formObj={formObj} handleFormChange={handleFormObjChange} setNotification={setNotification} windowWidth={layoutWidth} error={error} />}
                                    {currentStep === 9 && <Review isSingPass={isSingPass} formObj={formObj} agreement={agreement} setAgreement={setAgreement} isDirectSeller={isDirectSeller} error={error} />}
                                </Grid>
                            </Grid>
                        </Box>
                        // : <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
                        //     <div className="text-center">
                        //         <div className="header-2">{isDirectSeller ? (addAdvert?.data?.status === "draft" || draft === true ? "Your listing has been saved as draft." : "Your listing has been submitted for review.") : addAdvert?.data?.status === "draft" || draft === true ? "Your listing has been saved as draft." : "Your listing is now live on the marketplace."}</div>
                        //         <div className="my-3 mb-4">{isDirectSeller ? (addAdvert?.data?.status === "draft" || draft === true ? "You can continue editing and submit it for review anytime from Listing." : "Your listing will be live on the marketplace once approved by our team.") : addAdvert?.data?.status === "draft" || draft === true ? "You can continue editing and publish it anytime from Listing." : "You can track views and inquiries under Listing."}</div>
                        //         <CustomButton
                        //             title={'Go to Listing'}
                        //             press={() => navigate('/advert')}
                        //             padding={20}
                        //         />
                        //     </div>
                        // </div>
                    }
                </Container>
            </div>
            {
                currentStep <= totalPage && <div className="mobile-button-container d-flex justify-content-between">
                    <CustomButton
                        title={'Go Back'}
                        press={() => handleGoBack()}
                        borderStyle={'1px solid #1D1B1B'}
                        backgroundColor={'white'}
                        textColor={'#1D1B1B'}
                        padding={20}
                    />
                    {
                        currentStep === totalPage ?
                            <Stack direction="row" columnGap={1}>
                                <CustomButton
                                    title={'Save Draft'}
                                    press={() => { isDirectSeller ? handleDirectSellerVerifyForm(true) : handleVerifyForm(true); setDraft(true); }}
                                    padding={20}
                                    backgroundColor={'#F9F9F9'}
                                    textColor={currentStep === totalPage ? !agreement ? "#a8a8a8" : '#808588' : '#808588'}
                                    borderStyle={'1px solid #F9F9F9'}
                                    disabled={currentStep === totalPage ? !agreement : false}
                                />
                                <CustomButton
                                    title={'Publish Now'}
                                    disabled={currentStep === totalPage ? !agreement : false}
                                    backgroundColor={currentStep === totalPage ? !agreement ? '#6e6e6e' : '#1D1B1B' : '#1D1B1B'}
                                    press={() => { isDirectSeller ? handleDirectSellerVerifyForm() : handleVerifyForm(); setDraft(false); }}
                                    padding={20}
                                />
                            </Stack>
                            :
                            isDirectSeller && currentStep === 2 ?
                                <Stack direction="row" columnGap={1}>
                                    <CustomButton
                                        title={'FILL UP MANUALLY'}
                                        press={() => { handleFormObjChange('is_manually_fill', true); setCurrentStep(4) }}
                                        padding={20}
                                        backgroundColor={'transparent'}
                                        textColor={'#B48A3C'}
                                        fontSize={{ xs: 12, sm: 14 }}
                                        borderStyle={'1px solid transparent'}
                                    />
                                    <CustomButton
                                        title={'Retrieve Myinfo with Singpass'}
                                        press={() => handleRedirectSingpass()}
                                        backgroundColor={'#F4333D'}
                                        textColor={'white'}
                                        borderStyle={'none'}
                                        padding={10}
                                        fontSize={{ xs: 12, sm: 14 }}
                                        borderRadius={'5px'}
                                    />
                                </Stack>
                                : <CustomButton
                                    title={`${layoutWidth <= 768 ? 'Next' : `Next: ${steps[currentStep]?.buttonText || 'Publish Now'}`}`}
                                    press={() => isDirectSeller ? handleDirectSellerVerifyForm() : handleVerifyForm()}
                                    disabled={currentStep === totalPage ? !agreement : isDirectSeller && currentStep == 7 ? !formObj?.contact_agreement : false}
                                    backgroundColor={currentStep === totalPage ? !agreement ? '#6e6e6e' : '#1D1B1B' : isDirectSeller && currentStep == 7 ? !formObj?.contact_agreement ? '#6e6e6e' : '#1D1B1B' : '#1D1B1B'}
                                    padding={20}
                                />
                    }

                </div>
            }
            <AppDialog
                open={errorModalOpen}
                close={() => setErrorModalOpen(false)}
                customTitle={
                    <Stack direction="row" columnGap={1} alignItems="center">
                        <CustomButton
                            title={'Go back & Edit'}
                            press={() => { setErrorModalOpen(false) }}
                            padding={10}
                            backgroundColor={'white'}
                            textColor={'black'}
                            fontSize={{ xs: 12, sm: 14 }}
                            borderStyle={'1px solid black'}
                        />
                        <CustomButton
                            title={'Proceed to Submit'}
                            fontSize={{ xs: 12, sm: 14 }}
                            press={() => { setErrorModalOpen(false); isDirectSeller ? handleDirectSellerVerifyForm(false, true) : handleVerifyForm(false, true) }}
                            padding={10}
                            backgroundColor={'#d32f2f'}
                            textColor={'white'}
                            borderStyle={'1px solid #d32f2f'}
                        />
                    </Stack>
                } width={'50%'}
            >
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <ReportGmailerrorredIcon style={{ color: "#d32f2f" }} />
                    </Grid>
                    <Grid item xs={10}>
                        One or more of the uploaded images may contain visible plates number. Please ensure all images are properly masked before submitting.
                    </Grid>
                </Grid>
            </AppDialog>

            <SingpassLoginModal
                open={singpassLoginOpen}
                close={() => setSingpassLoginOpen(false)}
                handleLoginSingpass={() => handleLoginSingpass()}
            />
            <MakeModelChoosingModal
                open={chooseManualOpen}
                close={() => { setChooseManualOpen(false); }}
                handleSubmit={(e) => handleAddManually(e)}
                requestNewOpen={setRequestNewOpen}
                windowWidth={layoutWidth}
                formObj={formObj?.vehicle}
                setIsLoading={setIsLoading}
                setFormObj={setFormObj}
                setNotification={setNotification}
                handleFormChange={handleVehicleObjChange}
            />
            <RequestMakeModelModal
                open={requestNewOpen}
                close={() => setRequestNewOpen(false)}
                handleSubmit={() => { handleSubmitRequest() }}
                windowWidth={layoutWidth}
                formObj={requestObj}
                setFormObj={setRequestObj}
                makeList={makeList}
                error={error}
            />
            <VehicleDetailsSummaryModal
                advertType={formObj?.advert_type}
                open={vehicleDetailsOpen}
                close={() => setVehicleDetailsOpen(false)}
                selectedVehicle={isDirectSeller && formObj?.is_manually_fill ? formObj?.vehicle : erpDetails?.data}
                windowWidth={layoutWidth}
                bodyList={bodyList}
                isDirectSeller={isDirectSeller}
                isSingPass={isSingPass}

            />
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Layout, Advert, General }) {
    return {
        userData: Login?.verifyAdmin?.user?.data,
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        userPermission: Login?.permissionArry,
        leftSideBarType: Layout.leftSideBarType,
        layoutWidth: Layout.currentWidth,
        addAdvert: Advert.advertAdd,
        advertRequestMakeModel: Advert.advertRequestMakeModel,
        planList: General.bike_advert_plans,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        transmissionList: General.transmissions,
        license_categories: General.license_categories,
        erpDetails: Advert.erpDetails || null,
        erpListingInd: Advert.erpListing || null,
        singpassRes: Advert.singpassRes || null,
        generalCommonCode: General?.generalCommonCode || null,
    };
}


export default connect(mapStateToProps)(AddAdvert);
